import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import { url } from '@/helpers/UrlHelpers';

export default class deleteSpecialDates {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    async handle(occasionId) {
        const apiUrl = url(ApiEndpoints['users.updateSpecialDates'], [occasionId]);
        let request = await this.apiService
            .delete(apiUrl)
            .catch(() => false);

        return request;
    }
}
